const azureBlobBaseUrl = 'https://sorra.blob.core.windows.net/';
const imageProxyUrl = 'https://imgproxy.sorra.net/';
const defaultWidth = '1024';
const fileExtension = '@webp';
// example: https://sorra.blob.core.windows.net/xxx.jpg -> https://imgproxy.sorra.net/w1024/xxx@webp
const imageLoader = ({ src, width }) => {
  if (!src) {
    return '';
  }
  if (src.startsWith(azureBlobBaseUrl)) {
    return (
      src.replace(azureBlobBaseUrl, imageProxyUrl + 'w' + width + '/') +
      fileExtension
    );
  } else {
    return src;
  }
};

const WebpImg = (props) => {
  const { src, width, ...restProps } = props;
  if (!src) {
    return '';
  }

  const adjustedWidth = width || defaultWidth;
  const strapiSrc = imageLoader({ src, width: adjustedWidth });

  return <img src={strapiSrc} {...restProps} />;
};

export default WebpImg;
